/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Wilson Wong",
  title: "Howdy, I'm Wilson",
  subTitle: "",
  resumeLink:
    "https://drive.google.com/file/d/1xXaAWs8WPQKpKffawh6Q9emwOzIMvKOT/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/wilsonwong13",
  linkedin: "https://www.linkedin.com/in/wilsonwong13/",
  gmail: "wilsonwong13@gmail.com",
  medium: "https://medium.com/@wilsonwong13",
  display: true // Set true to display this section, defaults to false
};

// Skills Section


const skillsSection = {
    title: "Skills",
    subTitle: "",
    skills: [
      emoji("⚡ Develop demos to highlight a customer's story within a platform/product"),
      emoji("⚡ Lead technical calls for partner enablement sessions"),
      emoji("⚡ Delivering chatbots solutions to customers")
    ],
  
  /* Make Sure You include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */
  
    softwareSkills: [
      {
        skillName: "Salesforce",
        fontAwesomeClassname: "fab fa-salesforce"
      },
      {
        skillName: "Salesforce Lightning Aura, Apex",
        fontAwesomeClassname: "fas fa-bolt"
      },
      {
        skillName: "IBM Watson Technologies",
        fontAwesomeClassname: "fas fa-robot"
      },
      {
        skillName: "Twilio",
        fontAwesomeClassname: "fas fa-phone"
      },
      {
        skillName: "JavaScript",
        fontAwesomeClassname: "fab fa-js"
      },
      {
        skillName: "reactjs",
        fontAwesomeClassname: "fab fa-react"
      },
      {
        skillName: "nodejs",
        fontAwesomeClassname: "fab fa-node"
      },
      {
        skillName: "python",
        fontAwesomeClassname: "fab fa-python"
      },
      {
        skillName: "docker",
        fontAwesomeClassname: "fab fa-docker"
      }
    ],
  display: true
};
// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Rutgers",
      logo: require("./assets/images/Rutgers.png"),
      subHeader: "Bachelor of Arts (B.A.) in Molecular Biology and Biochemistry",
      duration: "September 2011 - April 2015",
      desc: "",
      descBullets: [
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
	  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Sales Engineer",  
      company: "IBM",
      companylogo: require("./assets/images/IBM-Logo.png"),
      date: "August 2017 – December 2020",
      desc: "Selling AI Solutions in Salesforce",
      descBullets: [
        "Delivered: Einstein Chatbot for a client's community page. Used to provide case status to user. Developed the dialog structure and flows for actions",
        "Delivered: Watson Assistant Integration to Salesforce Live Agent for a client's homepage",
        "Built demos showcasing the art of the possible implementing Watson / Einstein in Salesforce that is currently being used to support the sales team across all sectors in North America.",
        "Consulted / Supported various sales team in NA, EU, Asia, and South America on building AI solutions in Salesforce"
      ]
    },
{
        role: "Solutions Engineer",  
        company: "Kustomer",
        companylogo: require("./assets/images/Kustomer_Logo.png"),
        date: "January 2021 – Current",
        desc: "Focusing on Partners Relationship and Enablement",
        descBullets: [
          "Enabling Partners on the Kustomer Platform on how to build integration and selling value prop",
          "Building application to showcase the functionality with the Kustomer Platform", 
          "Lead architect/developer on Watson Assistant + Kustomer Integration",
          "Lead architect/developer on Twilio Flex + Kustomer Integration",
          "Lead architect/developer on RingCentral + Kustomer Integration"
        ]
      }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications"),
  subtitle:
    "",

  achievementsCards: [
        {
          title: "Salesforce Service Cloud",
          subtitle: "",
          image: require("./assets/images/service-cloud-cert.png"),
          footerLink: [
            { name: "Certification", url: "https://trailhead.salesforce.com/credentials/verification" }
          ]
        },
        {
          title: "Salesforce Administrator",
          subtitle: "",
          image: require("./assets/images/cert_admin_rgb.png"),
          footerLink: [
            { name: "Certification", url: "https://trailhead.salesforce.com/credentials/verification" }
          ]
        },
    {
            title: "Twilio Platform",
            subtitle: "",
            image: require("./assets/images/twilio.svg"),
            footerLink: [
              { name: "Certification", url: "https://drive.google.com/file/d/1WlmGHO2XbBtS1YB8H2sz3aVFE3IKN5dD/view" }
            ]
          },
      {
              title: "Twilio Flex",
              subtitle: "",
              image: require("./assets/images/twilio.svg"),
              footerLink: [
                { name: "Certification", url: "https://drive.google.com/file/d/1q7fJ6kCrNfvctQsgx-aaNk8kF5BKyy1r/view" }
              ]
            }
      ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "",

  blogs: [
  {
      url: "https://medium.com/@wilsonwong13/using-create-react-app-with-lightning-container-89b9764b886d",
      title: "Using Create-React-App with Salesforce Lightning Container",
      description: ""
    },
    {
      url: "https://medium.com/@wilsonwong13/create-your-own-google-call-screen-using-twilio-and-ibm-node-red-ca01d3fa34f0",
      title: "Create your own Google Call Screen using Twilio and Node-Red",
      description: ""
    },
    {
      url: "https://medium.com/@wilsonwong13/simplifying-chatbot-orchestration-layer-with-ibm-app-connect-402634b1b986",
      title: "Simplifying Virtual Assistant Orchestration Layer with App Connect",
      description: ""
    },
    {
      url: "https://medium.com/google-cloud/deploy-your-node-red-environment-onto-kubernetes-clusters-using-google-cloud-platform-2e4775c2e79f",
      title: "Deploy your Node Red Environment onto Kubernetes Clusters using GCP",
      description: "Step by Step on how to deploy Node-Red instance on Google Cloud Platforms. Article part of the Google Cloud Platform Community."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "Einstein Next Best Action",
      subtitle: "Guest Speaker at TrailheaDX 2019",
      event_url: "https://trailblazer.salesforce.com/sessions?eventId=a1Q3A000026slov#/session/a2q3A000002BGbGQAW",
      youtube_url: "https://www.youtube.com/watch?time_continue=2&v=-XU32ASXTjE"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
    title: emoji("Contact Me"),
    subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
    number: "+13479219692",
    email_address: "wilsonwong13@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "wjw51", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
